import React, { useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './AdminAccessPage.css';

export default function AdminAccessPage({ signedIn }) {
  const location = useLocation();
  const heading = useRef(null);
  const from = `${location.pathname}${location.search}${location.hash}`;

  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'Nothing there | Zimetafsiriwa';
    heading.current?.focus({ preventScroll: true });
    return () => { document.title = previousTitle; };
  }, []);

  return (
    <section className="admin-access" aria-labelledby="admin-access-title">
      <div className="admin-access__preview" aria-hidden="true">
        <div className="admin-access__window">
          <div className="admin-access__window-bar"><span>● ● ●</span><span>ZIME / CONTROL ROOM</span><span>PREVIEW</span></div>
          <div className="admin-access__mock-layout">
            <div className="admin-access__mock-nav"><b>Z.</b>{[0, 1, 2, 3].map(item => <i key={item} />)}</div>
            <div className="admin-access__mock-main">
              <div className="admin-access__mock-heading"><span /><span /></div>
              <div className="admin-access__mock-stats">{[0, 1, 2].map(item => <div key={item}><i /><b>— —</b><i /></div>)}</div>
              <div className="admin-access__mock-chart">{[32, 55, 42, 76, 58, 88, 66, 96, 75, 100].map((height, index) => <i key={index} style={{ '--bar-height': `${height}%`, '--bar-delay': `${index * 45}ms` }} />)}</div>
              <div className="admin-access__mock-rows">{[0, 1].map(item => <div key={item}><i /><span /><span /></div>)}</div>
            </div>
          </div>
          <div className="admin-access__scan" />
        </div>
        <div className="admin-access__lock">
          <span className="admin-access__lock-ring" />
          <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M15 21v-7a9 9 0 0 1 18 0v7" /><rect x="10" y="21" width="28" height="23" rx="6" /><path d="M24 30v5" /></svg>
        </div>
        <span className="admin-access__stamp">STAFF ONLY</span>
      </div>

      <div className="admin-access__copy">
        <span className="admin-access__badge"><i aria-hidden="true" />ENJOY THE SHOW</span>
        <h1 id="admin-access-title" ref={heading} tabIndex={-1}>Nothing there 😂</h1>
        <p className="admin-access__description">Continue enjoying our service.</p>
        <div className="admin-access__actions">
          <Link className="admin-access__button admin-access__button--primary" to="/">Back to the movies <span aria-hidden="true">→</span></Link>
          {!signedIn && <Link className="admin-access__button admin-access__button--secondary" to="/login" state={{ from }}>Admin sign in</Link>}
        </div>
      </div>
    </section>
  );
}
